<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <i-card-vertical headerTitle="관계법령 체크리스트" device="multi" contentsClass="overflow-x-hidden overflow-y-auto pr-5" :IsUseEditorBox="true">
        <template v-slot:EditorBox>
          <date-bar
            :firstDisplayDate="searchYear"
            :dateOnly="true"
            class="mx-1"
            label="조회년도"
            max-width="300px"
            year
            no-title
            style="max-width: 340px"
            @getDate="handleYearChange"
          ></date-bar>
          <v-select
            style="width: 120px"
            :menu-props="{ offsetY: true }"
            color="primary"
            item-text="minorNm"
            item-value="minorCd"
            :items="searchHalfList"
            placeholder="상반기/하반기"
            solo
            max-width="100px"
            class="editor_bg"
            v-model="searchHalfCd"
            @change="btnSearch()"
          />
        </template>
        <template v-slot:body>
          <v-simple-table>
            <template v-slot:default>
              <colgroup>
                <col style="width: 6%" />
                <col style="width: 30%" />
                <col style="width: 30%" />
                <col style="width: 8%" />
                <col style="width: 8%" />
                <col style="width: 8%" />
                <col style="width: 8%" />
              </colgroup>
              <tbody>
                <tr>
                  <td class="text-center tableTitle text-h6" style="width: 20%" rowspan="2">근거</td>
                  <td class="text-center tableTitle text-h6" style="width: 30%" rowspan="2">점검사항</td>
                  <td class="text-center tableTitle text-h6" style="width: 30%" rowspan="2">확인내용</td>
                  <td class="text-center tableTitle text-h6" style="width: 20%" colspan="4">결과</td>
                </tr>
                <tr>
                  <td v-for="value in valueList" :key="value.minorCd" class="text-center tableTitle">
                    <div class="d-flex align-center">
                      {{ value.minorNm }}
                      <DxCheckBox :value="isAllChecked(value.minorCd)" @valueChanged="onCheckAll($event, value)" />
                    </div>
                  </td>
                </tr>
                <template v-for="section in checklist">
                  <tr :key="section.sectionId">
                    <td class="text-start text-h6" colspan="7">{{ section.sectionNm }}</td>
                  </tr>
                  <template v-for="law in section.dataList">
                    <tr v-for="(item, itemIndex) in law.dataList" :key="section.sectionId + law.lawId + itemIndex">
                      <td v-if="itemIndex == 0" :rowspan="law.dataList.length">{{ law.lawNm }}</td>
                      <td
                        :colspan="item.checkContent == null || item.checkContent == '' ? 6 : 1"
                        :class="item.checkContent == null || item.checkContent == '' ? 'align-center' : 'align-top'"
                      >
                        {{ item.itemNm }}
                      </td>
                      <td v-if="item.checkContent != null && item.checkContent != ''">{{ item.checkContent }}</td>
                      <template v-if="item.checkContent != null && item.checkContent != ''">
                        <td v-for="value in valueList" :key="value.minorCd" class="text-center">
                          <DxCheckBox
                            :value="item.itemVal == value.minorCd ? true : false"
                            @valueChanged="onCheckValueChanged($event, item, value.minorCd)"
                          />
                        </td>
                      </template>
                    </tr>
                  </template>
                </template>
              </tbody>
            </template>
          </v-simple-table>
        </template>
      </i-card-vertical>
      <v-sheet class="iCardRightWrap">
        <i-card-right
          :useBtnList="buttonUseList"
          @btnSearch="btnSearch(true)"
          @btnSave="btnSave()"
          @btnDelete="btnDelete()"
          @btnPrint="btnPrint"
        ></i-card-right>
      </v-sheet>
    </v-sheet>
  </v-container>
</template>

<script>
// 공통 컴포넌트
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import iCardVertical from '@/components/common/iCardVertical.vue'
import dateBar from '@/components/common/dateBar.vue'
import DxCheckBox from 'devextreme-vue/check-box'
// utils
import { getCurrentDate } from '@/utils/common.js'
import { getPreMonth, getTodayHalf } from '@/utils/common.js'

// API
import { getCommonCode } from '@/api/common/commonApi'
import {
  getRelatedLegisChecklist,
  saveRelatedLegisChecklist,
  deleteRelatedLegisChecklist,
  getRelatedLegisChecklistReport,
} from '@/api/leaderShip/relatedLegisChecklist'
export default {
  mixins: [baseview],
  components: {
    'i-card-vertical': iCardVertical,
    DxCheckBox,
    dateBar,
  },
  data() {
    return {
      searchYear: getPreMonth(0), // 조회조건 - 년도
      searchHalfList: [], // 조회조건 - 상반기/하반기 구분
      searchHalfCd: '', // 조회조건 - 상반기/하반기 구분 코드값
      initCompId: '',
      buttonUseList: [
        'btnSearch', // 조회
        'btnSave', // 저장
        'btnDelete', // 삭제
        'btnPrint', // 출력
      ],
      checklist: [],
      valueList: [],
      isUpdating: false, // 체크박스 업데이트 중 플래그
    }
  },
  watch: {},
  computed: {},
  async created() {
    await getCommonCode('CM016').then((res) => {
      if (res.success) {
        this.searchHalfList = res.list
        if (!this.searchHalfCd) {
          this.searchHalfCd = res.list[getTodayHalf()].minorCd
          this.searchParams = {
            clntId: this.getClntId(),
            compId: this.getCompId(),
            writeYear: this.searchYear,
            halfDiv: this.searchHalfCd,
            versionId: '20250805', // 임시 하드코딩
          }
          this.btnSearch(true)
        }
      }
    })
  },
  beforeMount() {},
  mounted() {
    getCommonCode('CM020').then((res) => {
      this.valueList = res.list
    })
  },
  async activated() {
    if (!this.searchHalfCd) return
    this.searchParams = {
      clntId: this.getClntId(),
      compId: this.getCompId(),
      writeYear: this.searchYear,
      halfDiv: this.searchHalfCd,
      versionId: '20250805', // 임시 하드코딩
    }
    await this.btnSearch(true)
    // if (this.changedCompFlag(this.initCompId)) {
    //   // 로컬 스토리지에 저장된 값을 비교하여 변경 전 / 변경 후 compId가 다르고,
    //   // 페이지 진입시 세팅해두었던 compId 와 변경 후 compId와 다를 경우
    //   this.initCompId = this.getCompId()
    //   this.btnSearch(true)
    // }
  },
  methods: {
    handleYearChange(e) {
      this.searchYear = e.toString()
      this.btnSearch(true)
    },
    async btnSearch(notify = false) {
      this.openLoading()
      this.searchParams.halfDiv = this.searchHalfCd
      this.searchParams.writeYear = this.searchYear.substring(0, 4)
      getRelatedLegisChecklist(this.searchParams, notify)
        .then((res) => {
          if (res.success) {
            this.checklist = res.list
          }
        })
        .finally(() => {
          this.endLoading()
        })
    },
    async btnSave() {
      let saveData = []
      const clntId = this.getClntId()
      const compId = this.getCompId()
      saveData = this.checklist.flatMap((section) =>
        section.dataList.flatMap((law) =>
          law.dataList.map((item) => {
            return {
              ...item,
              clntId,
              compId,
              writeYear: this.searchYear.substring(0, 4),
              halfDiv: this.searchHalfCd,
            }
          })
        )
      )
      console.log('saveData', saveData)
      this.vToastifyPrompt(
        this.$t('저장하시겠습니까?'),
        'info',
        async (current) => {
          this.openLoading()
          saveRelatedLegisChecklist(saveData, true)
            .then((res) => {
              if (res.success) {
                this.btnSearch(false)
              }
            })
            .catch(() => {
              this.endLoading()
            })
            .finally(() => {
              this.endLoading()
            })
        },
        null,
        true
      )
    },
    async btnDelete() {
      console.log('btnDelete')
      this.vToastifyPrompt(
        this.$t('삭제하시겠습니까?'),
        'info',
        async (current) => {
          this.openLoading()
          deleteRelatedLegisChecklist(this.searchParams, true)
            .then((res) => {
              if (res.success) {
                this.btnSearch(false)
              }
            })
            .catch(() => {
              this.endLoading()
            })
            .finally(() => {
              this.endLoading()
            })
        },
        null,
        true
      )
    },
    async btnPrint(type) {
      this.openLoading()
      const param = {
        clntId: this.getClntId(),
        compId: this.getCompId(),
        writeYear: this.searchYear.substring(0, 4),
        halfDiv: this.searchHalfCd,
        versionId: '20250805', // 임시 하드코딩
        type: type,
      }
      getRelatedLegisChecklistReport(param, true)
        .then((res) => {
          this.downloadReport(res)
        })
        .catch(() => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
    },
    ///////////////////////////////////////
    /*               이벤트               */
    ///////////////////////////////////////
    // 각 컬럼별로 모든 항목이 체크되어 있는지 확인
    isAllChecked(minorCd) {
      if (!this.checklist || this.checklist.length === 0) {
        return false
      }
      let totalCount = 0
      let checkedCount = 0
      this.checklist.forEach((section) => {
        section.dataList.forEach((law) => {
          law.dataList.forEach((item) => {
            totalCount++
            if (item.itemVal === minorCd) {
              checkedCount++
            }
          })
        })
      })

      // 모든 항목이 체크되어 있고, 항목이 하나 이상 있을 때만 true
      return totalCount > 0 && totalCount === checkedCount
    },
    onCheckAll(event, valueItem) {
      // 프로그래밍적으로 발생한 이벤트는 무시 (중복 호출 방지)
      if (this.isUpdating) {
        return
      }
      const isChecked = event && event.value === true
      const minorCd = valueItem.minorCd
      // 현재 실제 상태 확인
      const currentAllChecked = this.isAllChecked(minorCd)
      // 사용자가 직접 클릭한 경우에만 처리 (상태가 변경되는 경우)
      if (isChecked === currentAllChecked) {
        // 프로그래밍적으로 발생한 이벤트 (상태 변경 없음)
        return
      }
      this.isUpdating = true
      // 해당 컬럼의 모든 항목에 체크/해제 적용
      this.checklist.forEach((section) => {
        section.dataList.forEach((law) => {
          law.dataList.forEach((item) => {
            if (isChecked) {
              // 체크 시: 해당 컬럼의 값으로 설정
              item.itemVal = minorCd
            } else {
              // 해제 시: 현재 값이 해당 컬럼과 같으면 null로 설정
              if (item.itemVal === minorCd) {
                item.itemVal = null
              }
            }
          })
        })
      })
      this.$nextTick(() => {
        this.isUpdating = false
      })
    },
    onCheckValueChanged(event, item, minorCd) {
      // 프로그래밍적으로 발생한 이벤트는 무시 (중복 호출 방지)
      if (this.isUpdating) {
        return
      }
      this.isUpdating = true
      // 실제로 체크된 경우에만 처리
      if (event && event.value === true) {
        const previousValue = item.itemVal
        // 현재 값과 다른 경우에만 업데이트
        if (previousValue !== minorCd) {
          item.itemVal = minorCd
        }
      } else {
        // 체크 해제 시
        if (item.itemVal === minorCd) {
          item.itemVal = null
        }
      }
      // 다른 체크박스들이 자동으로 해제되면서 발생하는 이벤트는 무시됨
      this.$nextTick(() => {
        this.isUpdating = false
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep td {
  white-space: pre-line;
  font-weight: 400;
  font-size: 1rem !important;
}

::v-deep td.align-top {
  vertical-align: top;
}
::v-deep td.align-center {
  vertical-align: center;
  font-weight: 600;
}
</style>
